<template>
    <TotemSelect
        v-if="departments.length > 0"
        :options="departments"
        :placeholder="$t('WatchListModal.department_filter_label')"
        @input="selectDepartment"
        class="filter-select-department"
        ref="shareWatchListDepartmentFilter"
        :width="getDepartmentFilterWidth"
        :value="departmentFilter"
    />
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'ShareWatchListDepartmentFilter',
        props: {
            departments: Array
        },
        computed: {
            ...mapGetters({
                departmentFilter: 'Watchlists/getShareWatchListDepartmentFilter',
            }),
            getDepartmentFilterWidth () {
                if (this.isDesktopView) {
                    return 160
                } else {
                    return '100%'
                }
            }
        },
        methods: {
            selectDepartment (option) {
                this.$store.dispatch('Watchlists/selectDepartment', option)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .filter-select-department {
        margin: 0 0 0 auto;
        padding: 0 5px 5px 0;
        border-bottom: 2px solid black;

        [class*="mobile"] & {
            border-bottom: none;
        }
    }
</style>
